import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { BlogProvider, SiteConfigManager } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';

import Blog from 'components/Blog/Blog';
import BlogList from 'components/Blog/BlogList';

const { BLOG } = COMPONENT_TYPES;

const BlogRouter = () => {
  const blog = SiteConfigManager.getComponentPath(BLOG);

  return (
    <BlogProvider>
      <Switch>
        <Route component={Blog} path={`${blog}/:id`} />
        <Route component={BlogList} path={`${blog}`} />
      </Switch>
    </BlogProvider>
  );
};

export default BlogRouter;
